// Bulletin de paie imprimable (A4) : un bulletin, ou tous ceux d'un mois (un par page).
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { comptaAPI } from '../../services/api';
import { apiError, dateFr, fcfa, PAYMENT_MODES } from '../../utils/format';
import { montantEnLettres } from '../../utils/lettres';

const NAVY = '#12284C';
const css = `
  @page { size: A4; margin: 10mm; }
  * { box-sizing: border-box; }
  body { margin: 0; background: #e9ecef; font-family: Arial, Helvetica, sans-serif; color: #111; }
  .toolbar { position: sticky; top: 0; z-index: 2; background: ${NAVY}; color: #fff; padding: 10px 16px; display: flex; gap: 12px; align-items: center; flex-wrap: wrap; }
  .toolbar button { background: #fff; color: ${NAVY}; border: 0; padding: 8px 14px; border-radius: 4px; font-weight: bold; cursor: pointer; }
  .page { width: 190mm; min-height: 277mm; margin: 12px auto; background: #fff; padding: 7mm; position: relative; display: flex; flex-direction: column; font-size: 11.5px; }
  .head { display: flex; justify-content: space-between; gap: 6mm; }
  .soc { flex: 1; line-height: 1.45; }
  .soc img { height: 52px; }
  .soc .rs { font-weight: bold; font-size: 13px; margin-top: 4px; }
  .soc .ids { color: #333; font-size: 10.5px; margin-top: 2px; }
  .titre { width: 76mm; border: 1.5px solid ${NAVY}; border-radius: 4px; overflow: hidden; align-self: flex-start; }
  .titre .t { background: ${NAVY}; color: #fff; text-align: center; font-weight: bold; font-size: 16px; letter-spacing: .5px; padding: 6px 0; }
  .titre table { width: 100%; border-collapse: collapse; }
  .titre td { padding: 4px 8px; border-top: 1px solid #c9cfd9; }
  .titre td:first-child { color: #555; width: 42%; }
  .titre td:last-child { font-weight: bold; text-align: right; }
  .sal { margin-top: 5mm; border: 1px solid #9aa3af; border-radius: 4px; display: grid; grid-template-columns: 1fr 1fr; }
  .sal > div { padding: 6px 10px; }
  .sal > div:first-child { border-right: 1px solid #c9cfd9; }
  .sal .nom { font-size: 14px; font-weight: bold; margin-bottom: 3px; }
  .kv { display: grid; grid-template-columns: 34mm 1fr; row-gap: 2px; }
  .kv span:nth-child(odd) { color: #555; }
  .pres { margin-top: 3mm; display: grid; grid-template-columns: repeat(4, 1fr); border: 1px solid #c9cfd9; border-radius: 4px; }
  .pres div { padding: 5px 8px; border-right: 1px solid #c9cfd9; }
  .pres div:last-child { border-right: 0; }
  .pres b { display: block; font-size: 13px; margin-top: 1px; }
  .pres span { color: #555; font-size: 10.5px; }
  table.rub { width: 100%; border-collapse: collapse; margin-top: 5mm; table-layout: fixed; }
  table.rub th { background: #EEF1F6; color: ${NAVY}; font-size: 10.5px; text-transform: uppercase; letter-spacing: .3px; text-align: left; padding: 6px 8px; border-bottom: 1.5px solid ${NAVY}; }
  table.rub td { padding: 5px 8px; border-bottom: 1px solid #e3e6eb; }
  table.rub .n { text-align: right; white-space: nowrap; font-variant-numeric: tabular-nums; }
  table.rub .code { color: #666; }
  table.rub tr.sub td { font-weight: bold; background: #F7F8FA; border-bottom: 1px solid #c9cfd9; }
  table.rub tr.tot td { font-weight: bold; border-top: 1.5px solid ${NAVY}; border-bottom: 0; }
  .net { margin-top: 4mm; display: flex; justify-content: space-between; align-items: center; background: ${NAVY}; color: #fff; border-radius: 4px; padding: 8px 12px; }
  .net .l { font-size: 13px; font-weight: bold; letter-spacing: .5px; }
  .net .v { font-size: 20px; font-weight: bold; font-variant-numeric: tabular-nums; }
  .lettres { margin-top: 2mm; font-style: italic; }
  .bas { margin-top: 5mm; display: grid; grid-template-columns: 1.25fr 1fr; gap: 6mm; }
  table.cum { width: 100%; border-collapse: collapse; }
  table.cum caption { text-align: left; font-weight: bold; color: ${NAVY}; margin-bottom: 3px; }
  table.cum th, table.cum td { border: 1px solid #c9cfd9; padding: 4px 6px; }
  table.cum th { background: #EEF1F6; font-weight: normal; font-size: 10.5px; }
  table.cum td { text-align: right; font-variant-numeric: tabular-nums; }
  .reg { line-height: 1.6; }
  .reg b { color: ${NAVY}; }
  .sign { margin-top: auto; padding-top: 8mm; display: grid; grid-template-columns: 1fr 1fr; gap: 10mm; }
  .sign div { border-top: 1px solid #9aa3af; padding-top: 4px; min-height: 26mm; position: relative; color: #444; }
  .sign img { position: absolute; left: 0; top: 6px; max-height: 24mm; max-width: 55mm; }
  .mention { margin-top: 3mm; font-size: 9.5px; color: #555; text-align: center; }
  .watermark { position: absolute; top: 45%; left: 50%; transform: translate(-50%, -50%) rotate(-28deg); font-size: 90px; font-weight: bold; color: rgba(200, 0, 0, .11); pointer-events: none; white-space: nowrap; }
  @media print {
    body { background: #fff; } .toolbar { display: none; }
    .page { margin: 0; width: auto; min-height: 0; height: 275mm; padding: 0; break-after: page; page-break-after: always; overflow: hidden; }
    .page:last-child { break-after: auto; page-break-after: auto; }
    .titre .t, .net, table.rub th, table.cum th, tr.sub td { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  }
`;

const moisLong = (p) => new Date(`${p}-01T00:00:00Z`).toLocaleDateString('fr-FR', { month: 'long', year: 'numeric', timeZone: 'UTC' });
const CONTRATS = { CDI: 'CDI', CDD: 'CDD', JOURNALIER: 'Journalier', STAGE: 'Stage', AUTRE: 'Autre' };
const f = (v) => (v ? fcfa(v) : '');

function Bulletin({ b, doc }) {
  const s = doc.societe;
  const gains = [
    ['100', 'Salaire de base', b.salaire_base, `${doc.jours_ouvres} j`],
    ['110', 'Indemnités (transport, logement…)', b.indemnites],
    ['120', 'Primes', b.primes],
    ['130', 'Heures supplémentaires', b.heures_sup],
  ].filter(([code, , v]) => code === '100' || v > 0);
  const cotis = [
    ['200', 'IPRES (part salariale)', b.ipres],
    ['210', 'IPM', b.ipm],
    ['220', 'Autres cotisations sociales', Math.max(0, b.cotisations - b.ipres - b.ipm)],
    ['300', 'Impôt sur le revenu (IR)', b.ir],
    ['310', 'TRIMF', b.trimf],
    ['320', 'Autres impôts', Math.max(0, b.impots - b.ir - b.trimf)],
    ['400', 'Avances et acomptes', b.avances],
    ['410', 'Autres retenues', b.autres_retenues],
  ].filter(([, , v]) => v > 0);
  const totalGains = b.salaire_base + b.indemnites + b.primes + b.heures_sup;
  const totalRetenues = b.retenue_absences + b.cotisations + b.impots + b.avances + b.autres_retenues;
  const annee = doc.periode.slice(0, 4);
  const mode = b.mode_paiement || b.mode_habituel;
  const watermark = b.statut === 'BROUILLON' ? 'BROUILLON' : null;
  const cachet = s.afficher_cachet && s.cachet_image && b.statut !== 'BROUILLON';

  return (
    <div className="page">
      {watermark && <div className="watermark">{watermark}</div>}
      <div className="head">
        <div className="soc">
          <img src="/logo-docc.png" alt="DOCC" />
          <div className="rs">{s.raison_sociale}</div>
          {s.adresse && <div>{s.adresse}</div>}
          {s.telephone && <div>Tél : {s.telephone}</div>}
          <div className="ids">
            {[s.ninea && `NINEA : ${s.ninea}`, s.rccm && `RCCM : ${s.rccm}`].filter(Boolean).join(' · ')}
            {(s.ipres_employeur || s.css_employeur) && <br />}
            {[s.ipres_employeur && `N° IPRES : ${s.ipres_employeur}`, s.css_employeur && `N° CSS : ${s.css_employeur}`].filter(Boolean).join(' · ')}
          </div>
        </div>
        <div className="titre">
          <div className="t">BULLETIN DE PAIE</div>
          <table><tbody>
            <tr><td>Période</td><td style={{ textTransform: 'capitalize' }}>{moisLong(doc.periode)}</td></tr>
            <tr><td>N°</td><td>{b.numero}</td></tr>
            <tr><td>Paiement</td><td>{b.date_paiement ? dateFr(b.date_paiement) : '—'}</td></tr>
          </tbody></table>
        </div>
      </div>

      <div className="sal">
        <div>
          <div className="nom">{b.prenom} {b.nom}</div>
          <div className="kv">
            <span>Matricule</span><span>{b.matricule}</span>
            <span>Emploi</span><span>{b.poste || '—'}</span>
            {b.service && <><span>Service</span><span>{b.service}</span></>}
            <span>Catégorie</span><span>{b.categorie || '—'}</span>
          </div>
        </div>
        <div>
          <div className="kv" style={{ marginTop: 2 }}>
            <span>Contrat</span><span>{CONTRATS[b.type_contrat] || b.type_contrat}</span>
            <span>Date d'embauche</span><span>{b.date_embauche ? dateFr(b.date_embauche) : '—'}</span>
            <span>N° IPRES</span><span>{b.numero_ipres || '—'}</span>
            <span>Règlement</span><span>{PAYMENT_MODES[mode] || '—'}</span>
            {(b.banque || b.compte) && <><span>Banque / compte</span><span>{[b.banque, b.compte].filter(Boolean).join(' · ')}</span></>}
          </div>
        </div>
      </div>

      <div className="pres">
        <div><span>Jours ouvrés du mois</span><b>{doc.jours_ouvres}</b></div>
        <div><span>Absences retenues</span><b>{String(b.jours_absence).replace('.', ',')} j</b></div>
        <div><span>Jours payés</span><b>{String(b.jours_travailles).replace('.', ',')}</b></div>
        <div><span>Statut</span><b>{{ BROUILLON: 'Brouillon', VALIDE: 'Validé', PAYE: 'Payé' }[b.statut]}</b></div>
      </div>

      <table className="rub">
        <colgroup><col style={{ width: '9%' }} /><col style={{ width: '45%' }} /><col style={{ width: '12%' }} /><col style={{ width: '17%' }} /><col style={{ width: '17%' }} /></colgroup>
        <thead><tr><th>Code</th><th>Rubrique</th><th className="n">Base</th><th className="n">Gains</th><th className="n">Retenues</th></tr></thead>
        <tbody>
          {gains.map(([code, l, v, base]) => (
            <tr key={code}><td className="code">{code}</td><td>{l}</td><td className="n">{base || ''}</td><td className="n">{fcfa(v)}</td><td /></tr>
          ))}
          {b.retenue_absences > 0 && (
            <tr><td className="code">150</td><td>Retenue pour absences non justifiées</td><td className="n">{String(b.jours_absence).replace('.', ',')} j</td><td /><td className="n">{fcfa(b.retenue_absences)}</td></tr>
          )}
          <tr className="sub"><td /><td>Salaire brut</td><td /><td className="n">{fcfa(b.brut)}</td><td /></tr>
          {cotis.map(([code, l, v]) => (
            <tr key={code}><td className="code">{code}</td><td>{l}</td><td /><td /><td className="n">{f(v)}</td></tr>
          ))}
          {cotis.length === 0 && <tr><td /><td style={{ color: '#777' }}>Aucune retenue sur le brut</td><td /><td /><td /></tr>}
          <tr className="tot"><td /><td>Totaux</td><td /><td className="n">{fcfa(totalGains)}</td><td className="n">{fcfa(totalRetenues)}</td></tr>
        </tbody>
      </table>

      <div className="net"><span className="l">NET À PAYER</span><span className="v">{fcfa(b.net)} FCFA</span></div>
      <div className="lettres">Arrêté le présent bulletin à la somme de : <b>{montantEnLettres(b.net)}</b>.</div>

      <div className="bas">
        <table className="cum">
          <caption>Cumuls de l'année {annee} (janvier à {moisLong(doc.periode).split(' ')[0]})</caption>
          <thead><tr><th>Brut</th><th>Cotisations</th><th>Impôts</th><th>Net</th></tr></thead>
          <tbody><tr><td>{fcfa(b.cumuls.brut)}</td><td>{fcfa(b.cumuls.cotisations)}</td><td>{fcfa(b.cumuls.impots)}</td><td>{fcfa(b.cumuls.net)}</td></tr></tbody>
        </table>
        <div className="reg">
          {b.statut === 'PAYE' ? (
            <>Payé le <b>{dateFr(b.date_paiement)}</b> par <b>{PAYMENT_MODES[b.mode_paiement] || '—'}</b>{b.reference ? <> · réf. {b.reference}</> : null}</>
          ) : <>Mode de règlement prévu : <b>{PAYMENT_MODES[mode] || '—'}</b></>}
          {b.commentaire && <div style={{ marginTop: 4 }}>Observation : {b.commentaire}</div>}
        </div>
      </div>

      <div className="sign">
        <div>L'employeur{cachet && <img src={s.cachet_image} alt="Cachet" />}</div>
        <div>Le salarié — « Pour acquit »</div>
      </div>
      <div className="mention">Conservez ce bulletin de paie sans limitation de durée : il vous permet de faire valoir vos droits.</div>
    </div>
  );
}

/** Route /compta/paie/bulletins/:id/imprimer ou /compta/paie/:periode/imprimer */
const BulletinPrint = () => {
  const { id, periode } = useParams();
  const [doc, setDoc] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    (id ? comptaAPI.bulletinDocument(id) : comptaAPI.bulletinsDocuments(periode))
      .then((r) => {
        setDoc(r.data);
        const one = r.data.bulletins.length === 1 ? r.data.bulletins[0] : null;
        document.title = one ? `${one.numero} ${one.nom} ${one.prenom}` : `Bulletins de paie ${r.data.periode}`;
      })
      .catch((e) => setError(apiError(e)));
  }, [id, periode]);

  if (error) return <div style={{ padding: 24 }}>{error}</div>;
  if (!doc) return <div style={{ padding: 24 }}>Chargement…</div>;
  const n = doc.bulletins.length;
  return (
    <>
      <style>{css}</style>
      <div className="toolbar">
        <strong>{n === 1 ? doc.bulletins[0].numero : `${n} bulletins de paie`}</strong>
        <span style={{ marginRight: 'auto', textTransform: 'capitalize' }}>{n === 1 ? `${doc.bulletins[0].prenom} ${doc.bulletins[0].nom} · ` : ''}{moisLong(doc.periode)}</span>
        <button onClick={() => window.print()}>Imprimer / PDF</button>
      </div>
      {doc.bulletins.map((b) => <Bulletin key={b.id} b={b} doc={doc} />)}
    </>
  );
};

export default BulletinPrint;
